module.exports = __webpack_public_path__ + "static/media/QRcodeSerios-appleStore.b7a64faa.svg";